<div class="filter time-tab" ngModelGroup="dateTimeGroup" #time="ngModelGroup">
  <div class="timeTab__citation-date filter__column-breaker_large filter__column-breaker_medium">
    <app-citation-date-filter [citationDates]="citationDates"
      [dateTimePreset]="dateTimePreset"
      [timeframePreset]="timeframePreset"
      (changeDateTime)="citationDateChange($event)"
    />
  </div>
  <div class="time-tab__week-day">
    <app-filter-item [title]="'Day of week'" [value]="weekDayValue" [clearFilter]="clearFilter('daysOfWeek')">
      <mat-form-field appearance="outline" class="filter__select_full">
        <mat-select multiple
                    name="daysOfWeek"
                    placeholder="Day of week"
                    [(ngModel)]="dateTimeGroup.daysOfWeek"
        >
          <mat-option *ngFor="let day of weekDays" [value]="day.value">
            {{day.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </app-filter-item>
  </div>
  <div class="time-tab__month filter__column-breaker_large">
    <app-filter-item [title]="'Month'" [value]="monthValue" [clearFilter]="clearFilter('months')">
      <mat-form-field appearance="outline" class="filter__select_full">
        <mat-select multiple
                    name="months"
                    placeholder="Month"
                    [(ngModel)]="dateTimeGroup.months"
        >
          <mat-option *ngFor="let month of months" [value]="month.value">
            {{month.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </app-filter-item>
  </div>
  <div class="time-tab__day-night filter__column-breaker_large">
    <app-time-filter></app-time-filter>
  </div>
  <div class="time-tab__timeframe-preset">
    <app-timeframe-preset-filter [timeframePreset]="timeframePreset" (timeframePresetChange)="timeframePresetChange($event)" />
  </div>

</div>
